import {createActionTypes} from "../utils/reduxUtils";

enum pageActionTypes {
    CHANGE_BACKGROUND
}

const actionTypes = createActionTypes(pageActionTypes, "PAGE");

export default actionTypes;

export const Background = {
    LANDING: 'LANDING',
    APIS: 'APIS',
    DEFAULT: 'DEFAULT',
    LOGIN: 'LOGIN'
};